import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../../store/directusService';
import { setCurrentlySelectedParticipant } from '../../../../store/participantService';
import {
    ADVISER,
    hasRole,
    MANAGER,
    QUALITY,
    RECRUITMENT_MANAGER,
    SUPERUSER
} from '../../../../utils/userRoles';
import Button from '../../../formElements/Button';

import classes from '../../../../commonStyles/tables.module.css';

const RemoveParticipantRow = ({ row, roles, type, onRemoveRow }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const acceptedRoles = [ADVISER, MANAGER, QUALITY, RECRUITMENT_MANAGER, SUPERUSER];
    const [isNavRequestSent, setIsNavRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USEEFFECTS
    useEffect(() => {
        if (isNavRequestSent && currentParticipant?.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isNavRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isNavRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [contractDetailsById, servicesByContractId, isNavRequestSent, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        dispatch(setCurrentlySelectedParticipant(row));
        setIsNavRequestSent(true);
    };

    return (
        <TableRow
            hover
            className={`${classes.basicRowStripes} ${type === 'SMS' ? classes.rowHeight : ''}`}>
            <TableCell align="center" className={classes.rowLink} onClick={onClickPTCode}>
                {row.ptCode}
            </TableCell>
            <TableCell align="center">{row.firstName}</TableCell>
            <TableCell align="center">{row.lastName}</TableCell>
            <TableCell align="center">
                {type === 'SMS' ? (
                    <>{row.selectedContact.contactNumber}</>
                ) : (
                    <>{row.emailAddress === 'z' ? ' - ' : row.emailAddress}</>
                )}
            </TableCell>
            <TableCell align="center">
                {row.currentStatus === 'zz' ? ' - ' : row.currentStatus}
            </TableCell>
            <TableCell align="center">
                <Button
                    id="removeParticipantButton"
                    customClass="noButtonMargin"
                    content="Remove"
                    disabled={!hasRole(acceptedRoles, roles)}
                    onClick={(e) => {
                        e.preventDefault();
                        onRemoveRow();
                    }}
                />
            </TableCell>
        </TableRow>
    );
};

export default RemoveParticipantRow;

RemoveParticipantRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    onRemoveRow: PropTypes.func
};
